import { render } from "./Persons.vue?vue&type=template&id=5ef81b0a&scoped=true"
import script from "./Persons.vue?vue&type=script&lang=js"
export * from "./Persons.vue?vue&type=script&lang=js"

import "./Persons.vue?vue&type=style&index=0&id=5ef81b0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef81b0a"]])

export default __exports__